import { LeadSystemSource, Source } from '../../../interfaces/onboarding';

export enum Gender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
}

export type Option = {
  label: string;
  value: string;
};

export type ReferralFormFields = {
  firstName: string;
  lastName: string;
  dob: Date;
  referredBy: string;
  preferredLanguage: string;
  feet: number | null;
  weight: number | null;
  inches: number | null;
  gender?: string;
  city?: string;
  insurancePlanType: string;
  insuranceName: string;
  insuranceId: number | null;
  otherInsuranceName?: string;
  zipCode: string;
  street?: string;
  state?: string;
  phone?: number | null;
  outsideMRN: number | null;
  email?: string;
  bmi: number | null;
  groupNumber?: number | null;
  agentEmail: string;
  systemSource: LeadSystemSource;
  source: Source;
  clinicId: number;
  metadata?: {
    secondaryInsurance?: {
      insurancePlanType?: string;
      insuranceName?: string;
      insuranceId?: number | null;
      otherInsuranceName?: string;
      groupNumber?: number | null;
    };
  };
};
